import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-subtitle mb-0" }
const _hoisted_4 = {
  class: "card-body overflow-scroll py-0",
  id: "chat_card_body",
  style: {"height":"calc(100vh - 442px)"}
}
const _hoisted_5 = { class: "card-footer" }
const _hoisted_6 = {
  class: "modal-body py-0 d-flex flex-column",
  id: "chat_modal_body"
}
const _hoisted_7 = { class: "modal-footer" }

import { computed, ref } from "vue";
import moment from "moment";
import { useChatRoomConfigStore } from "@/store/useChatRoomConfigStore";
import { useSessionStore } from "@/store/useSessionStore";
import { chatDefaultMessage } from "@/constants";
import ChatRoomContent from "./ChatRoomContent.vue";
import ChatRoomInput from "./ChatRoomInput.vue";
import { useChatRoom, useSendChatMessage, useEditChatMessage } from "@/composables/useChat";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatRoom',
  props: {
    type: {}
  },
  setup(__props: any) {



const store = useChatRoomConfigStore();
const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const chatId = computed(() => store.config?.id as number | undefined);
const chatDate = computed(() => store.config?.date as string | undefined);
const user_name = computed(() => store.config?.user_name as string);

const defaultMessage = chatDefaultMessage;

const { sectionItems, loadingChat, formatted_date, invalidateMessages } = useChatRoom(chatId, chatDate);

const { mutate: sendMessageMutation } = useSendChatMessage();
const { mutateAsync: editMessageMutation } = useEditChatMessage();

const editingMessageId = ref<number | null>(null);
const editMessageText = ref("");

function handleSend(msg: string) {
  if (!chatId.value) return;
  sendMessageMutation(
    { appointment_chat_id: chatId.value, message: msg },
    { onSuccess: () => invalidateMessages() },
  );
}

function canEditMessage(item: any) {
  const created = moment(item.created_at || item.date);
  return moment().diff(created, "minutes") < 15;
}

function startEdit(item: any) {
  editingMessageId.value = item.id;
  editMessageText.value = item.message;
}

function cancelEdit() {
  editingMessageId.value = null;
  editMessageText.value = "";
}

async function submitEdit(item: any) {
  const text = editMessageText.value.trim();
  if (!text) return;
  try {
    await editMessageMutation({ id: item.id, message: text });
    invalidateMessages();
    cancelEdit();
  } catch (error) {
    console.error("submitEdit", error);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'screen')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(user_name.value), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_unref(loadingChat))
              ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
              : (_openBlock(), _createBlock(ChatRoomContent, {
                  key: 1,
                  formattedDate: _unref(formatted_date),
                  sectionItems: _unref(sectionItems),
                  defaultMessage: _unref(defaultMessage),
                  sessionId: session.value?.id,
                  editingMessageId: editingMessageId.value,
                  editMessageText: editMessageText.value,
                  canEditMessage: canEditMessage,
                  onStartEdit: startEdit,
                  onCancelEdit: cancelEdit,
                  onSubmitEdit: submitEdit,
                  "onUpdate:editMessageText": _cache[0] || (_cache[0] = ($event: any) => (editMessageText.value = $event))
                }, null, 8, ["formattedDate", "sectionItems", "defaultMessage", "sessionId", "editingMessageId", "editMessageText"]))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ChatRoomInput, { onHandleSend: handleSend })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.type === 'modal')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            (_unref(loadingChat))
              ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
              : (_openBlock(), _createBlock(ChatRoomContent, {
                  key: 1,
                  formattedDate: _unref(formatted_date),
                  sectionItems: _unref(sectionItems),
                  defaultMessage: _unref(defaultMessage),
                  sessionId: session.value?.id,
                  editingMessageId: editingMessageId.value,
                  editMessageText: editMessageText.value,
                  canEditMessage: canEditMessage,
                  onStartEdit: startEdit,
                  onCancelEdit: cancelEdit,
                  onSubmitEdit: submitEdit,
                  "onUpdate:editMessageText": _cache[1] || (_cache[1] = ($event: any) => (editMessageText.value = $event))
                }, null, 8, ["formattedDate", "sectionItems", "defaultMessage", "sessionId", "editingMessageId", "editMessageText"]))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ChatRoomInput, { onHandleSend: handleSend })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})